import { Component, OnInit, Input } from '@angular/core';
import {Video} from '../../models/video/video';
import {Router} from '@angular/router';
import * as moment from 'moment';
import {LiveEvent} from '../../models/live-event/live-event';

@Component({
  selector: 'app-video-item',
  templateUrl: './video-item.component.html',
  styleUrls: ['./video-item.component.scss']
})
export class VideoItemComponent implements OnInit {
  @Input()
  video: LiveEvent;
  formattedStartTime: string;
  constructor(private router: Router) { }

  ngOnInit() {
    const d = new Date(this.video.startTime);
    this.formattedStartTime = moment(d).calendar();
  }

  watchVideo(id) {
    debugger;
    this.router.navigate(['/watch/' + id]);
  }

}
